import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=7744f6de&scoped=true&"
var script = {}
import style0 from "./Basic.vue?vue&type=style&index=0&id=7744f6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7744f6de",
  null
  
)

export default component.exports